import { PRO_MAIN_PAGE_VISITS } from '../constants';

export function saveProMainPageView() {
  const currentVisits = parseInt(
    localStorage.getItem(PRO_MAIN_PAGE_VISITS) || '0',
    10
  );
  localStorage.setItem(PRO_MAIN_PAGE_VISITS, `${currentVisits + 1}`);
}
